/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const postCallPerformanceChart = (params) =>
  makeApiCall(`/nsm-call-performance-dashboard/chart`, 'POST', params);

export const postCallPerformanceDetailedView = (params) =>
  makeApiCall(`/nsm-call-performance-dashboard/detailed-view`, 'POST', params);

export const postPlottedMdsBreakdown = (params) =>
  makeApiCall(`/nsm-call-performance-dashboard/breakdown-view/plotted-mds`, 'POST', params);
// CALL PERFORMANC BREAKDOWN
export const postFrequencyvsPlottedBreakdown = (params) =>
  makeApiCall(
    `/nsm-call-performance-dashboard/breakdown-view/frequency-vs-plotted`,
    'POST',
    params,
  );

export const postCallRateBreakdown = (params) =>
  makeApiCall(`/nsm-call-performance-dashboard/breakdown-view/call-rate`, 'POST', params);

export const postCallReachBreakdown = (params) =>
  makeApiCall(`/nsm-call-performance-dashboard/breakdown-view/call-reach`, 'POST', params);

export const postCallConcentrationBreakdown = (params) =>
  makeApiCall(`/nsm-call-performance-dashboard/breakdown-view/call-concentration`, 'POST', params);

// CALL PERFORMANCE EXPORT
export const postPlottedMdsBreakdownExport = (params) =>
  makeApiCall(`/nsm-call-performance-dashboard/breakdown-view/plotted-mds/export`, 'POST', params);

export const postFrequencyvsPlottedBreakdownExport = (params) =>
  makeApiCall(
    `/nsm-call-performance-dashboard/breakdown-view/frequency-vs-plotted/export`,
    'POST',
    params,
  );

export const postCallRateExport = (params) =>
  makeApiCall(`/nsm-call-performance-dashboard/breakdown-view/call-rate/export`, 'POST', params);

export const postCallReachBreakdownExport = (params) =>
  makeApiCall(`/nsm-call-performance-dashboard/breakdown-view/call-reach/export`, 'POST', params);

export const postCallConcentrationBreakdownExport = (params) =>
  makeApiCall(
    `/nsm-call-performance-dashboard/breakdown-view/call-concentration/export`,
    'POST',
    params,
  );
